/**
 * Module dependencies.
 */

import { css } from '@emotion/react';
import styled from '@emotion/styled';

/**
 * Container css.
 */

const containerCss = css`
  height: 40vh;

  @media (max-width: 1200px) {
    height: 20vh;
  }

  @media (max-width: 992px) {
    height: 25vh;
  }

  @media (max-width: 768px) {
    height: 25vh;
  }

  @media (max-width: 576px) {
    height: 200px;
  }
`;

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  position: relative;
  clip-path: polygon(0% 0%, 100% 0%, 100% 90%, 0% 100%);
  overflow: hidden;

  ${containerCss}
`;

/**
 * Export `Background` styled component.
 */

export const Background = styled.div`
  background: linear-gradient(135deg, #0e1824 0%, #1a2a3a 100%);

  ${containerCss}
`;

/**
 * Export `MapsContainer` styled component.
 */

export const MapsContainer = styled.div`
  opacity: 1;
`;

/**
 * Export `Image` styled component.
 */

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.05;
`;
